import { render } from "./OnlineSupport.vue?vue&type=template&id=c0ebf630&scoped=true"
const script = {}

import "./OnlineSupport.vue?vue&type=style&index=0&id=c0ebf630&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0ebf630"]])

export default __exports__